import Image from 'src/components/common/Image'
import { spacing } from 'src/constants/marketing-ds'
import styled from 'styled-components'

const CashAppDarkLogo = () => (
  <Image
    src={'https://assets-imgx.fubo.tv/marketing/lp/images/apps/cashapppay-logomark.png?w=200'}
  />
)

const CashAppLightLogo = () => (
  <Image
    src={'https://assets-imgx.fubo.tv/marketing/lp/images/networks/cashapp-logo-m-v2.png?w=170'}
  />
)
export const CashAppLogo = ({ text, isDark = false }) => (
  <CashAppBulletStyled>
    <div>{text}</div>
    {isDark ? <CashAppLightLogo /> : <CashAppDarkLogo />}
  </CashAppBulletStyled>
)

const CashAppBulletStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  white-space: nowrap;
  div {
    margin-right: ${spacing.xxxs};
  }
  img {
    width: 115px;
    margin-top: 0;
    object-fit: contain;
  }
`
